import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import BoletoDefault from './BoletoDefault/index';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import BoletoProducer from './BoletoProducer/index';
import { pixelService, enPixelPath } from 'services/PixelService';

interface IState extends IStateBase {
  data: IThankYouPage;
}
export default class BoletoPage extends BaseComponent<IState>{

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    pixelService.track(enPixelPath.THANKYOU_BANKSLIP);
  }

  render() {
    return (
      <div>
        {this.props.infos.isDefault ?
          <BoletoDefault infos={this.props.infos} /> :
          <BoletoProducer infos={this.props.infos} />
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/BoletoPage/index.tsx